import { render, staticRenderFns } from "./LinkSettings.vue?vue&type=template&id=e8eb57fe&"
import script from "./LinkSettings.vue?vue&type=script&lang=js&"
export * from "./LinkSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports